import React from 'react';
import Icon from '../../../components/AppIcon';

const ApplicationProgress = ({ currentStep, totalSteps }) => {
  const steps = [
    { id: 1, label: 'Personal Info', icon: 'User' },
    { id: 2, label: 'Documents', icon: 'FileText' },
    { id: 3, label: 'Questions', icon: 'MessageSquare' },
    { id: 4, label: 'Review', icon: 'CheckCircle' }
  ];

  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Application Progress</h3>
        <span className="text-sm font-medium text-primary">{Math.round(progress)}% Complete</span>
      </div>
      <div className="relative mb-6">
        <div className="h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-primary transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {steps?.map((step) => (
          <div 
            key={step?.id}
            className={`flex items-center gap-3 p-3 rounded-lg transition-smooth ${
              step?.id <= currentStep 
                ? 'bg-primary/10 border border-primary/20' :'bg-muted border border-border'
            }`}
          >
            <div className={`flex items-center justify-center w-10 h-10 rounded-full ${
              step?.id <= currentStep ? 'bg-primary text-primary-foreground' : 'bg-background text-muted-foreground'
            }`}>
              <Icon name={step?.icon} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-medium truncate ${
                step?.id <= currentStep ? 'text-foreground' : 'text-muted-foreground'
              }`}>
                {step?.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApplicationProgress;